<template>
  <table :class="['searcher-results', 'w3-table', 'search']" :key="contentId">
    <thead>
      <tr>
        <th v-for="header in searcherHeaderShow" :key="header.id"
          :class="{'boolean' : getType(header.id) === 'boolean'}"
        >
          <searcher-header
            :header="header"
            @refreshHeaderOrder="refreshHeaderOrder"
          />
        </th>
        <th v-if="showGoToDetail">
        </th>
      </tr>
    </thead>
    <tbody>
      <template v-for="(row, index) in rows">
        <tr
          :class="['resultat_taula', {'detailOpened' : isDetailOpened(row.requestIdValue)}, {'get' : showGoToDetail && getColumnIdValue(row.requestIdValue) !== ''}]"
          @click="resultSelected(row.requestIdValue)"
          :key="`row-${index}`"
        >
          <td
            v-for="column in getRowColumns(row.requestIdValue)" :key="column.id"
            :class="getType(column.id)"
          >
            <span v-if="getType(column.id) === 'boolean'" class="boolean"><i :class="getBooleanIconValue(column.value)"></i></span>
            <span v-else-if="getType(column.id) === 'image'" class="image">
              <iframe class="iframe-image" scrolling="no" :srcdoc="column.value" @load.once="imageIframeLoaded" />
            </span>
            <span v-else-if="getType(column.id) === 'url' && column.value !== ''"><a class="urlLink" :href="column.value" target="_blank">{{ column.value }} <i class="fas fa-external-link-alt"></i></a></span>
            <span v-else-if="getType(column.id) === 'menu' && column.value !== '' && column.valueId !== '' && column.menuId !== ''"><span class="urlLink" v-on:click.stop="loadMenu(column.menuId, column.valueId)">{{ column.value }}</span></span>
            <span v-else-if="getType(column.id) === 'link' && column.value !== '' && column.menuId !== ''"><span class="urlLink" v-on:click.stop="loadLink(column.menuId)">{{ column.value }}</span></span>
            <span v-else v-html="column.value"></span>
          </td>
          <td
            v-if="showGoToDetail"
            v-tooltip="{content: $ml.get('id').toUpperCase() + ': ' + getColumnIdValue(row.requestIdValue), delay: { show: 400, hide: 100 }}"
            :class="['id_arrow']"
          >
            <i v-if="getColumnIdValue(row.requestIdValue) !== ''" class="fa fa-angle-right"></i>
          </td>
        </tr>
        <tr
          v-if="detailInRow && rowDetails[getColumnIdValue(row.requestIdValue)].open"
          class="resultat_taula_detail"
          :key="`row-detail-${index}`"
        >
          <td
            v-for="column in getRowIdColumn(row.requestIdValue)" :key="column.id"
            :colspan="getDetailColspan(row.requestIdValue)"
          >
            <transition name="fade" mode="out-in">
              <div v-show="rowDetails[column.value].open" :class="['row_detail_content', column.value]">
                <transition name="fade" mode="out-in">
                  <definition-loader v-if="rowDetails[column.value].loaderProps"
                    v-bind="rowDetails[column.value].loaderProps"
                    :searcherDetailDefinition="true"
                    @formDataActionCalled="formDataActionCalled"
                  />
                  <spinner-loading v-else class="spinner-loading" size="25" />
                </transition>
              </div>
            </transition>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
import SearcherHeader from '@/components/content/searcher/header'
import transport from 'vue-definition-utils/src/utils/transport'
import * as api from '@/utils/api'
import DefinitionLoader from '@/components/content/definitionLoader'
import menu from '@/utils/menu'

export default {
  name: 'searcher-table',
  props: [
    'idColumn',
    'idMenuColumn',
    'codeColumn',
    'externalUrlColumn',
    'searcherHeader',
    'rows',
    'detailInRow',
    'detailInRowType',
    'showId',
    'contentId',
    'showGoToDetail'
  ],
  data () {
    return {
      rowDetails: {
      }
    }
  },
  components: {
    SearcherHeader,
    DefinitionLoader
  },
  beforeMount () {
    // init rowDetail
    for (var j = 0; j < this.rows.length; j++) {
      var columns = this.rows[j].requestIdValue
      // this.$set for binding new object
      this.$set(this.rowDetails, this.getColumnIdValue(columns), {open: false, loaderProps: null})
    }
  },
  methods: {
    resultSelected (columns, event) {
      if (!this.detailInRow) {
        this.$emit('resultSelected', columns)
      } else {
        var id = this.getColumnIdValue(columns)

        // -- open detail inside row
        if (this.detailInRowType) {
          this.rowDetails[id].open = !this.rowDetails[id].open
          if (!this.rowDetails[id].loaderProps) {
            api.call({access: api.ACCESS_SERVICES, url: this.detailInRowType.endpoint, method: 'POST', data: { id: this.contentId, code: id }})
              .then(resp => {
                var loaderProps = {
                  content: resp
                }
                loaderProps.content.endpoint = this.detailInRowType.endpoint
                loaderProps.content.id = this.detailInRowType.content.id
                loaderProps.id = this.detailInRowType.content.id
                loaderProps.name = this.detailInRowType.content.name
                loaderProps.type = this.detailInRowType
                loaderProps.saveDefinition = false
                loaderProps.saveDefinitionTo = null
                loaderProps.detailParentContentId = this.contentId

                this.rowDetails[id].loaderProps = loaderProps
              })
              .catch(err => {
                console.error(err)
              })
          }
        } else {
          this.$emit('resultSelected', columns)
        }
      }
    },
    getColumnIdValue (columns) {
      var result = ''
      if (this.externalUrlColumn !== '') {
        result = transport.methods.getSearcherColumnValue(columns, this.externalUrlColumn)
      } else if (this.idColumn !== '') {
        result = transport.methods.getSearcherColumnValue(columns, this.idColumn)
      }
      return result
    },
    refreshHeaderOrder (id, order) {
      this.$emit('refreshHeaderOrder', id, order)
    },
    isDetailOpened (columns) {
      var result = false
      var rowDetail = this.rowDetails[this.getColumnIdValue(columns)]
      if (rowDetail) {
        result = rowDetail.open
      }
      return result
    },
    getDetailColspan (columns) {
      var result = columns.length
      if (this.showId) {
        result += 1
      }
      return result
    },
    formDataActionCalled (stay) {
      this.$emit('refreshDefinitionContent')
    },
    getBooleanIconValue (value) {
      var result

      result = ''

      if (value) {
        value = value.toLowerCase()
      }

      if (value === '1' || value === 'true' || value === 'si' || value === 'active' || value === 's') {
        result += 'fa fa-check'
      } else if (value === '0' || value === 'false' || value === 'no' || value === 'inactive' || value === 'n') {
        result += 'fa fa-times'
      } else {
        result += ''
      }

      return result
    },
    getType (id) {
      return this.getHeader(id).type
    },
    getShow (id) {
      return this.getHeader(id).show
    },
    getHeader (id) {
      var result = null

      for (var i = 0; i < this.searcherHeader.length && !result; i++) {
        if (this.searcherHeader[i].id === id) {
          result = this.searcherHeader[i]
        }
      }

      return result
    },
    columnShow (requestIdValue) {
      var result = []
      for (var i = 0; i < requestIdValue.length; i++) {
        var column = requestIdValue[i]

        if (this.getShow(column.id) && ((column.id !== this.idColumn && column.id !== this.codeColumn && column.id !== this.externalUrlColumn) || this.showId)) {
          result.push(column)
        }
      }
      return result
    },
    columnDetailShow (requestIdValue) {
      var result = []
      for (var i = 0; i < requestIdValue.length; i++) {
        var column = requestIdValue[i]

        if (column.id === this.idColumn) {
          result.push(column)
        }
      }
      return result
    },
    getRowColumns (row) {
      var result = []
      for (var i = 0; i < row.length; i++) {
        var column = row[i]
        if (this.getHeader(column.id).show &&
          ((column.id !== this.idColumn && column.id !== this.codeColumn && column.id !== this.externalUrlColumn) || this.showId) &&
          column.id !== this.idMenuColumn
        ) {
          result.push(column)
        }
      }
      return result
    },
    getRowIdColumn (row) {
      var result = []
      for (var i = 0; i < row.length; i++) {
        var column = row[i]
        if (column.id === this.idColumn) {
          result.push(column)
        }
      }
      return result
    },
    loadMenu (menuId, valueId) {
      menu.methods.loadDetailView(menuId, valueId)
    },
    loadLink (link) {
      window.open(link, '_blank')
    },
    imageIframeLoaded (event) {
      let doc = event.target.contentWindow.document
      if (doc.body) {
        if (!this.editable) {
          doc.body.style.zoom = '20%'
        }
      }
    }
  },
  computed: {
    searcherHeaderShow () {
      var result = []
      for (var i = 0; i < this.searcherHeader.length; i++) {
        var header = this.searcherHeader[i]
        if (header.show &&
          ((header.id !== this.idColumn && header.id !== this.codeColumn && header.id !== this.externalUrlColumn) || this.showId) &&
          header.id !== this.idMenuColumn
        ) {
          result.push(header)
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss">
table.searcher-results {
  background-color: #fff;
  border-collapse:separate;
  border-spacing: 0 5px;

  > thead > tr > th {
    font-family: "Source Sans Pro", sans-serif;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: normal;
    color: #554b5a;
    text-align: left;
    padding: 5px 20px 5px 8px !important;

    &.boolean {
      span {
        display: block;
        width: 100%;
        text-align: center;
      }
      .order-sort {
        width: 100%;
        text-align: center;
        margin-left: 0;
      }
    }

    &.code {
      display: none;
    }
  }

  tr.resultat_taula {
    background-color: #f8f8f8;
    transition: background-color 0.2s;
    transition-timing-function: cubic-bezier(.16,1.03,.41,.82);
  }

  > tbody > tr > td {
    font-family: 'Noto Sans';
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 16px;
    letter-spacing: normal;
    line-break: anywhere;
    color: #000;
    padding: 6px 15px 6px 7px !important;
    vertical-align: middle;
    transition: color 0.2s;
    transition-timing-function: cubic-bezier(.16,1.03,.41,.82);
    float: none !important;

    &.image {
      max-width: 170px;
      width: 170px;
      text-align: center;

      .iframe-image {
        border: 0;
        width: 95%;
      }
    }

    &.code {
      display: none;
    }

    &.id_arrow {
      max-width: 20px;
      width: 30px;
      text-align: right;
    }

    span.boolean {
      display: block;
      width: 100%;
      text-align: center;

      .fa-times {
        color: #f87474;
      }

      .fa-check {
        color: #2dd32d;
      }
    }

    span.image {
      max-height: 160px;
      width: 160px;
      display: block;
      overflow: hidden;
      background-color: #fefefe;
      border: 1px solid #e0e0e0;
    }
  }
}

table.searcher-results {
  tr.resultat_taula {
    > td.id, > td.id_arrow {
      /* text-align: right;
      font-size: 18px; */

      i {
        transition: all 0.2s;
        color: #d42e12;
        font-size: 16px;
      }
    }

    .urlLink {
      text-decoration: none;
      color: #568bcb;
      cursor: pointer;

      i {
        font-size: 12px;
        margin-left: 5px;
      }

      &:hover {
        text-decoration: underline;
      }
    }

    &.detailOpened {
      td {
        &.id_arrow {
          color: #d42e12;

          i {
            transform: rotate(90deg);
          }
        }
      }
    }
  }

  tr.resultat_taula_detail > td {
    padding: 0;

    .definition-title {
      display: none;
    }

    .multiselect__content-wrapper {
        position: relative;
    }
  }

  .row_detail_content {
    background-color: #fff;
    padding: 0 15px;
    border-left: 1px solid #e4e4e4;

    .groupTasks {
      float: none;
      padding: 0;

      .searcher-filters {
        display: none;
      }

      .contenidor_taula {
        margin: 0;
        min-height: auto;

        .loadingResults {
          min-height: auto !important;
        }

        td:first-child,
        td:last-child {
          border: 0;
        }
      }

      .searcher-results {
        border: 0;
      }

      #paginador {
        border: 0;

        .pages {
          background-color: transparent;
          margin-top: 0;
          padding: 3px 3px 2px;

          .movePage.disabled {
            background-color: transparent !important;
          }

          .results {
            display: none;
          }
        }
      }
    }

    #type_actions {
      position: relative !important;
      background-color: transparent !important;
      height: 50px !important;
      z-index: 1 !important;
      left: 0 !important;

      .buttons {
        margin-top: 0;
        width: 60%;

        button {
          width: auto;
          min-width: auto;
          height: 40px !important;
          margin-right: 0 !important;

          &.update-and-stay,
          &.save-and-stay {
            display: none;
          }

          span {
            font-size: 16px !important;
          }
        }
      }

      .messages {
        margin-top: 0;
      }
    }

    .definition-wrapper {
      &.group {
        background-color: #fff !important;
        padding: 0 !important;
      }
    }

    .list-complete-item {
      max-height: 100px;

      .buttons {
        display: none;
      }

      .complete-item {
        padding: 0 10px 0;
      }
    }
  }

  tr.get.resultat_taula:hover {
    background-color: #DBEBEE;
    cursor: pointer;
  }

  tr.get.resultat_taula:hover td {
    color: #5698A2;

    &.id_arrow {
      color: #d42e12;
    }
  }
}

.detail-wrapper {
  table.searcher-results {
    border-left: 1px solid #e4e4e4;
    border-right: 1px solid #e4e4e4;
  }

  td:first-child {
    border-left: 1px solid #e4e4e4;
  }

  td:last-child {
    border-right: 1px solid #e4e4e4;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/content/searcher/table.vue